import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  CircularProgress,
  Typography,
} from "@mui/material";
import { MdCheckCircle, MdCancel } from "react-icons/md"; // Icons for boolean values
import axios from "axios";

function Selected() {
  const [tab, setTab] = useState("single");
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const rowsPerPage = 5;

  useEffect(() => {
    const fetchSelectedData = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axios.get("https://puneexpobackend.tdtlworld.com/api/get_idea_submission/");
        // Filter only approved entries
        const filteredData = response.data.filter((item) => item.approved === true);
        setData(filteredData);
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchSelectedData();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setCurrentPage(1);
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const renderIcon = (value) => {
    return value ? (
      <MdCheckCircle style={{ color: "green", fontSize: "1.2rem" }} />
    ) : (
      <MdCancel style={{ color: "red", fontSize: "1.2rem" }} />
    );
  };

  const renderTable = () => {
    const filteredData = tab === "single"
      ? data.filter((item) => item.type === "single")
      : data.filter((item) => item.type === "group");

    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

    if (currentData.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={6} align="center">
            <Typography variant="body1" color="textSecondary">
              Currently no project selected.
            </Typography>
          </TableCell>
        </TableRow>
      );
    }

    if (tab === "single") {
      return (
        <TableBody>
          {currentData.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell>{index + 1 + startIndex}</TableCell>
              <TableCell>{row.title || "N/A"}</TableCell>
              <TableCell>{row.description || "N/A"}</TableCell>
              <TableCell>{renderIcon(row.submit)}</TableCell>
              <TableCell>{renderIcon(row.inprogressed)}</TableCell>
              <TableCell>{renderIcon(row.viewed)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      );
    } else {
      return (
        <TableBody>
          {currentData.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell>{index + 1 + startIndex}</TableCell>
              <TableCell>{row.groupName || "N/A"}</TableCell>
              <TableCell>{row.leader || "N/A"}</TableCell>
              <TableCell>{row.members || "N/A"}</TableCell>
              <TableCell>{renderIcon(row.submit)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      );
    }
  };

  return (
    <Box sx={{ margin: "70px", padding: "20px", textAlign: "center" }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Selected Projects
      </Typography>

      {/* Tabs */}
      <Box sx={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab value="single" label="Single" />
          <Tab value="group" label="Group" />
        </Tabs>
      </Box>

      {/* Table and Loading/Error States */}
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "800px", margin: "0 auto", backgroundColor: "#E8F4FA" }}
        >
          <Table>
            <TableHead>
              {tab === "single" ? (
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Submitted</TableCell>
                  <TableCell>In Progress</TableCell>
                  <TableCell>Viewed</TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Group Name</TableCell>
                  <TableCell>Leader</TableCell>
                  <TableCell>Members</TableCell>
                  <TableCell>Submitted</TableCell>
                </TableRow>
              )}
            </TableHead>
            {renderTable()}
          </Table>
        </TableContainer>
      )}

      {/* Pagination */}
      {!loading && !error && (
        <Box sx={{ margin: "20px auto", display: "flex", justifyContent: "center" }}>
          <Pagination
            count={Math.ceil(
              (tab === "single"
                ? data.filter((item) => item.type === "single").length
                : data.filter((item) => item.type === "group").length) / rowsPerPage
            )}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
}

export default Selected;
